<template>
  <el-dialog
    title=""
    :visible.sync="isShowModel"
    top="0"
    :close-on-click-modal="false"
    width="480px"
    :show-close="false"
    custom-class="VerifyModel"
  >
    <div class="dialog-head">
      <span></span>
      <fm-button
        @click="handleClose"
        type="info"
        size="mini"
        text
        icon="icon-model-close"
      ></fm-button>
    </div>
    <div class="dialog-content">
      <div class="v-title">
        <img :src="$utils.getPng('icon20')" />
        <span class="title">您的账号存在安全风险</span>
      </div>
      <span class="desc"
        >请使用您账号绑定手机号对应的手机打开「飞猫盘」APP扫描此二维码进行安全验证</span
      >
      <div class="code" v-if="!isVerifyRefresh" v-loading="verifyLoading">
        <img :src="noWaitQRCode" />
      </div>
      <div class="code2" v-else>
        <img class="ewm" :src="$utils.getPng('ewm')" />
        <div class="mb1" @click="refresh">
          <img class="imgdb" :src="$utils.getPng('iconsx')" alt="" />
          <span>请点击刷新</span>
        </div>
      </div>
      <div class="gohelp">
        <span>无法验证？前往 </span><span @click="gohelp">帮助中心</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowModel: Boolean,
    isVerifyRefresh: Boolean,
    verifyLoading: Boolean,
    noWaitQRCode: String,
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    refresh() {
      this.$emit('refresh')
    },
    gohelp() {
      window.open(this.$glb.feemooUrl + '/help')
    },
  },
}
</script>

<style></style>
